import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import type { UserRole } from '@anchor-comms/shared';
import { useSession } from '@/features/auth/auth';

export function RequireAuth({ children, role }: { children: ReactNode; role?: UserRole }) {
  const { data: user, isLoading } = useSession();
  const location = useLocation();

  if (isLoading) return <div className="p-6 text-sm text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/sign-in" replace state={{ from: location }} />;
  if (role && user.role !== role) return <Navigate to="/conversations" replace />;
  return <>{children}</>;
}
